//SCSS
import '../scss/main.scss';
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/offcanvas');
require('masonry-layout/masonry');
//JS
import './petits-modules/_all';
import './modules/_all';
